import {action, makeAutoObservable} from "mobx";
import CommonStore from "../../../stores/CommonStore";
import Promotion from "../../../entities/Promotion";
import {PromotionService} from "../../../service/PromotionService";
import Agency from "../../../entities/Agency";
import { AgencyService } from "../../../service/AgencyService";

class NewPromotionStore {

    public promotionId?: string;
    public promotion: Promotion;
    public isEditing: boolean;
    public isModalOpen: boolean;
    public loading: boolean;

    public agencies: Agency[];

    public commonStore: CommonStore;
    public agencyId?: string;

    constructor(commonStore: CommonStore, promotionId?: string, agencyId?: string) {
        this.isEditing = !!promotionId;
        this.promotionId = promotionId;
        this.isModalOpen = false;
        this.promotion = {} as Promotion;
        this.loading = false;
        this.commonStore = commonStore;
        this.agencyId = agencyId;
        this.agencies = [];
        makeAutoObservable(this);
    }

    @action
    public async loadPromotion() {
        if (this.promotionId) {
            this.isEditing = true;
            const response = await PromotionService.find(this.promotionId!)
            if (response.success && response.data) {
                this.promotion = response.data;
            }
            this.commonStore.processErrors(response);
        }
    }

    @action
    public async loadAgencies() {
        const response = await AgencyService.get(1, 1000);
        if (response.success && response.data) {
            this.agencies = response.data.data;
        }
    }

    @action
    public async openModal() {
        this.loading = true;
        await this.loadPromotion();
        this.isModalOpen = true;
        this.loading = false;
    }

    @action
    public closeModal() {
        this.isModalOpen = false;
        this.promotion = {} as Promotion;
    }

    @action
    public async save(): Promise<boolean> {
        this.loading = true;
        this.promotion.agencyId = this.agencyId;
        const serviceToCall = this.isEditing ? PromotionService.update : PromotionService.create;
        const response = await serviceToCall(this.promotion);
        this.commonStore.processErrors(response);
        this.processError(response.error);
        this.loading = false;
        return response.success;
    }

    processError(error?: string) {
    }
}

export default NewPromotionStore;